import {
  requestMicroFrontendFetch,
  sendMicroFrontendFetchResponse,
} from '@wellesley/host-remote/api/actions'
import { sendMessage } from '@wellesley/host-remote/common/message/sendMessage'
import { listenMessage } from '@wellesley/host-remote/common/message/listenMessage'

import { deserializeRequest, serializeResponse } from '../../serialize'
import { MutableRefObject, useEffect, useRef } from 'react'
import { authToken } from '@wellesley/auth/helpers/token'
import { wlsyFetch } from '../../wlsyFetch'
import { emit } from '../fetchInterceptor'
import { logger } from 'helpers/logger'

const setAuthHeader = (headers: Headers) => {
  const token = authToken.getToken()
  if (token) {
    headers.set('authorization', `Bearer ${token}`)
  }
}

export const useHostFetch = (
  iframeRef: MutableRefObject<HTMLIFrameElement | null>,
  isActive: boolean,
) => {
  const unsubscribeRef = useRef<() => void>(() => {})
  useEffect(() => {
    if (!isActive) {
      unsubscribeRef.current()
      return
    }

    unsubscribeRef.current = listenMessage({
      sourceWindow: iframeRef.current?.contentWindow ?? null,
      onMessage: async ({
        payload: { id, options },
      }: ReturnType<typeof requestMicroFrontendFetch>) => {
        const deserializedOptions = deserializeRequest(options)
        setAuthHeader(deserializedOptions.headers)
        const res = await wlsyFetch(deserializedOptions)

        const response = await serializeResponse(res)

        try {
          emit(options, response)
        } catch (error) {
          logger.error('Error in fetch interceptor handler:', error)
        }

        sendMessage({
          action: sendMicroFrontendFetchResponse({
            id,
            response,
          }),
          windowElement: iframeRef.current?.contentWindow ?? window,
          whitelist: [sendMicroFrontendFetchResponse],
        })
      },
      whitelist: [requestMicroFrontendFetch],
    })

    return () => {
      unsubscribeRef.current()
    }
  }, [isActive])
}
